import { EventDtoTypeEnum } from 'src/Services/API/generated';

const eventTypeColors: Record<EventDtoTypeEnum, { bgColor: string; fgColor: string }> = {
  OCCUPATION: { bgColor: '#DE3163', fgColor: '#ffffff' },
  LOCATION: { bgColor: '#1B1B1B', fgColor: '#ffffff' },
  END_OF_CONTRACT: { bgColor: '#9F8170', fgColor: '#000000' },
  ENTRETIEN: { bgColor: '#BEBFC5', fgColor: '#000000' },
  WORK: { bgColor: '#1B4D3E', fgColor: '#ffffff' },
  ACTIVITIES: { bgColor: '#15F4EE', fgColor: '#000000' },
  OTHER: { bgColor: '#9966CC', fgColor: '#ffffff' },
  PUBLIC_HOLIDAY: { bgColor: '#FFD700', fgColor: '#000000' },
  SCHOOL_HOLIDAY_ZONE_A: { bgColor: '#FF8C00', fgColor: '#000000' },
  SCHOOL_HOLIDAY_ZONE_B: { bgColor: '#6CB4EE', fgColor: '#000000' },
  SCHOOL_HOLIDAY_ZONE_C: { bgColor: '#ACE1AF', fgColor: '#000000' },
};

export default eventTypeColors;
